/* eslint-disable perfectionist/sort-objects */
export const URL = {
  LOGIN: 'v1/auth/login',
  SSO_START: 'v1/auth/sso/start',
  SSO_START_BY_CONNECTION: 'v1/auth/sso/start-by-connection',
  SSO_CALLBACK: 'v1/auth/sso/callback',
  LOGOUT: 'v1/auth/logout',
  REFRESH: 'v1/auth/refresh',
  MFA_ENROLL: 'v1/auth/mfa-enroll',
  MFA_VERIFY: 'v1/auth/mfa-verify',
  MFA_CHALLENGE: 'v1/auth/mfa-challenge',
  SEND_EMAIL_VERIFICATION: 'v1/auth/send-email-verification',
  CHECK_EMAIL_VERIFICATION: 'v1/auth/check-email-verification',
  FORGOT_PASSWORD: 'v1/auth/forgot-password',

  PROFILE_DETAILS: 'v1/auth/profile',
  PROFILE_TENANT_DETAILS: 'v1/auth/profile/tenant',

  PROJECT_LIST: 'v1/projects',
  PROJECT_CREATE: 'v1/projects/create',
  PROJECT_DETAILS: 'v1/projects/:id',
  PROJECT_ADMIN_CONFIG: 'v1/projects/:id/admin-config',
  PROJECT_UPDATE: 'v1/projects/:id',
  PROJECT_DUPLICATE: 'v1/projects/:id/duplicate',
  PROJECT_REPORT: 'v1/projects/:id/export/:reportId',
  PROJECT_REPORT_CSV: 'v1/projects/:id/export/:reportId/csv',
  PROJECT_HEALTH_DEPARTMENTS: 'v1/projects/:id/health-departments',

  TENANT_LIST: 'v1/tenants',
  TENANT_DETAILS: 'v1/tenants/:id',
  TENANT_DUPLICATE: 'v1/tenants/:id/duplicate',
  TENANT_AUTO_TRANSLATE: 'v1/tenants/:id/auto-translate',
  TENANT_EMAIL_DOMAIN_CHANGE: 'v1/tenants/:id/email-domain-change',
  TENANT_REPORT: 'v1/tenants/:id/export/:reportId',
  TENANT_REPORT_CSV: 'v1/tenants/:id/export/:reportId/csv',
  TENANT_PROFILE_FORM_VERSIONS: 'v1/tenants/:id/profile-form-used-versions',
  TENANT_GAME_ANALYTICS_SUMMARY: 'v1/tenants/:id/game-analytics/summary',
  TENANT_GAME_ANALYTICS_PLAYERS: 'v1/tenants/:id/game-analytics/players',
  TENANT_GAME_ANALYTICS_SESSIONS_REPORT:
    'v1/tenants/:id/game-analytics/sessions-report',
  TENANT_GAME_ANALYTICS_SESSIONS_REPORT_EXPORT:
    'v1/tenants/:id/game-analytics/sessions-report.csv',
  TENANT_GAME_ANALYTICS_DETAILS_REPORT:
    'v1/tenants/:id/game-analytics/details/:kind/report',

  USER_LIST: 'v1/users',
  USER_IMPORTS: 'v1/users/imports',
  USER_CREATE: 'v1/users',
  USER_DETAILS: 'v1/users/:id',
  USER_PROFILE_FORM: 'v1/users/:id/profile-form',
  USER_CHANGE_STATUS: 'v1/users/:id/status',
  USER_CHANGE_DEMO: 'v1/users/:id/demo',
  USER_CHANGE_TENANTS: 'v1/users/:id/tenants',
  USER_CHANGE_PROJECTS: 'v1/users/:id/projects',
  USER_MFA_STATUS: 'v1/users/:id/mfa-status',
  USER_RESET_AUTH_APP_MFA: 'v1/users/:id/mfa/auth-app',
  USER_CHANGE_HEALTH_DEPARTMENT_SCOPES: 'v1/users/:id/health-department-scopes',
  USER_MESSAGE_ORG_ADMINS: 'v1/users/message-org-admins',
  USER_PDF_REPORTS: 'v1/users/:userId/pdf-reports',
  USER_PDF_REPORT_DETAILS: 'v1/users/:userId/pdf-reports/:reportId',
  USER_PDF_REPORT_DOWNLOAD_URL:
    'v1/users/:userId/pdf-reports/:reportId/download-url',
  USER_PDF_REPORT_RESTORE: 'v1/users/:userId/pdf-reports/:reportId/restore',
  USER_PDF_REPORT_LOGS: 'v1/users/:userId/pdf-reports/logs',

  AUDIT_EVENTS: 'v1/audit-events',
  AUDIT_EVENTS_EXPORT: 'v1/audit-events/export',
  AUDIT_EVENTS_BY_USER: 'v1/audit-events/:id',

  FORM_LIST: 'v1/forms',
  FORM_DETAILS: 'v1/forms/:id',
  FORM_DUPLICATE: 'v1/forms/:id/duplicate',
  FORM_REFERENCE_ITEMS:
    'v1/forms/:formId/fields/:fieldId/reference-items/search',

  UPLOAD_IMAGE: '/v1/files/image',

  COURSE_LIST: 'v1/courses',
  COURSE_DETAILS: 'v1/courses/:id',
  COURSE_DUPLICATE: 'v1/courses/:id/duplicate',
  COURSE_AUTO_TRANSLATE: 'v1/courses/:id/auto-translate',
  COURSE_VERSIONS: 'v1/courses/:id/used-versions',
  COURSE_REPORT: 'v1/courses/:id/export/:version/report/:reportId',
  COURSE_REPORT_CSV: 'v1/courses/:id/export/:version/report/:reportId/csv',

  COURSE_STEPS_LIST: 'v1/course-steps',
  COURSE_STEP_FIELD_SOURCES: 'v1/course-steps/form-field-sources/:courseId',
  COURSE_STEP_DETAILS: 'v1/course-steps/:id',
  COURSE_STEP_DUPLICATE: 'v1/course-steps/:id/duplicate',
  COURSE_SUBMISSIONS: 'v1/course-submissions',
  COURSE_SUBMISSION_COMPLETED: 'v1/course-submissions/:id/completed',

  RESOURCES_LIST: 'v1/resources',
  RESOURCES_DETAILS: 'v1/resources/:id',

  LIBRARY_TAGS: 'v1/library/:tenantId/tags',
  LIBRARY_TAGS_TREE: 'v1/library/:tenantId/tags/tree',
  LIBRARY_TAG_DETAILS: 'v1/library/:tenantId/tags/:id',
  LIBRARY_TAG_IMPORT: 'v1/library/:tenantId/tags/import',

  LIBRARY_RESOURCES: 'v1/library/:tenantId/resources',
  LIBRARY_RESOURCE_DETAILS: 'v1/library/:tenantId/resources/:id',
  LIBRARY_RESOURCE_IMPORT: 'v1/library/:tenantId/resources/import',

  CHILDREN: 'v1/children',
  CHILDREN_DETAILS: 'v1/children/:id',
  CHILDREN_LAST_COURSE_SUBMISSION_STATUS:
    'v1/children/:id/last-course-submission-status',
  CHILDREN_ADD_TO_LAST_COURSE_SUBMISSION:
    'v1/children/:id/add-to-last-course-submission',

  REPORT_TEMPLATES: 'v1/report-templates',
  REPORT_TEMPLATE_DETAILS: 'v1/report-templates/:id',

  REPLICATION_DESTINATIONS: 'v1/replication/destinations',
  REPLICATION_DESTINATION_TENANTS:
    'v1/replication/destinations/:destinationName/tenants',
  REPLICATION_PUSH_COURSE: 'v1/replication/push/course',
  REPLICATION_PUSH_PROFILE_FORM: 'v1/replication/push/profile-form',
  REPLICATION_PUSH_TENANT: 'v1/replication/push/tenant',
  REPLICATION_PUSH_PROJECT: 'v1/replication/push/project',
  REPLICATION_DESTINATION_PROJECTS:
    'v1/replication/destinations/:destinationName/projects',
};
